import type { CapabilityTreatment } from '@hopdrive/feature-portal-products';

/**
 * Whether an embed write control renders: the product's capability gate says render, and the
 * embed's `readOnly` setting is off. Both must allow it, so a lapsed product and a read-only
 * iframe each withhold the control on their own.
 */
export function writeAllowed(treatment: CapabilityTreatment, readOnly: boolean): boolean {
  return treatment.kind === 'render' && !readOnly;
}
